// Coeficientes do piso mínimo de frete — Resolução ANTT nº 6.084/2026
// (vigência 2026). Atualizar sempre que sair nova resolução.
//
// Fórmula: Piso = CCD * distancia_km + CC
//
// Tabelas (Anexo da Resolução 6.084/2026):
//   A = Composição veicular completa, operação padrão (Lotação)
//   B = Apenas unidade tratora, operação padrão
//   C = Composição veicular completa, Alto Desempenho (carga+descarga <= 3h)
//   D = Apenas unidade tratora, Alto Desempenho
//
// Estrutura: TABELAS[tabela][tipoCarga][eixos] = { ccd, cc }
//
// Fonte oficial (17 ago 2026):
//   https://anttlegis.antt.gov.br/action/ActionDatalegis.php?acao=abrirTextoAto
//     &tipo=RES&numeroAto=00006084&seqAto=000&valorAno=2026&orgao=DG/ANTT/MT
//
// Combinacoes eixos x tipo de carga sem valores oficiais na resolucao
// (ex.: Granel Pressurizada com 2 ou 3 eixos, Conteinerizada com 2
// eixos, Tabelas B/D com 2 ou 3 eixos) ficam AUSENTES no objeto e
// getCoeficientes() devolve null - forcando o front a exibir erro
// "combinacao nao cadastrada" em vez de calcular com valor inventado.

export const TIPOS_CARGA = [
  { value: 'CARGA_GERAL', text: 'Carga Geral' },
  { value: 'GRANEL_SOLIDO', text: 'Granel Sólido' },
  { value: 'GRANEL_LIQUIDO', text: 'Granel Líquido' },
  { value: 'NEOGRANEL', text: 'Neogranel' },
  { value: 'FRIGORIFICADA', text: 'Frigorificada / Aquecida' },
  { value: 'CONTEINERIZADA', text: 'Conteinerizada' },
  { value: 'GRANEL_PRESSURIZADA', text: 'Granel Pressurizada' },
  { value: 'PERIGOSA_GERAL', text: 'Perigosa - Carga Geral' },
  { value: 'PERIGOSA_GRANEL_SOLIDO', text: 'Perigosa - Granel Sólido' },
  { value: 'PERIGOSA_GRANEL_LIQUIDO', text: 'Perigosa - Granel Líquido' },
  { value: 'PERIGOSA_FRIGORIFICADA', text: 'Perigosa - Frigorificada' },
  { value: 'PERIGOSA_CONTEINERIZADA', text: 'Perigosa - Conteinerizada' }
]

export const EIXOS_DISPONIVEIS = [2, 3, 4, 5, 6, 7, 9]

export const TABELAS_INFO = [
  { value: 'A', text: 'A — Composição completa (padrão)' },
  { value: 'B', text: 'B — Apenas tração (padrão)' },
  { value: 'C', text: 'C — Composição completa (Alto Desempenho)' },
  { value: 'D', text: 'D — Apenas tração (Alto Desempenho)' }
]

export const TABELAS_ANTT_6084_2026 = {
  // ═══════════════════════════════════════════════════════════════════
  // TABELA A — Composição veicular completa, operação padrão (Lotação)
  // ═══════════════════════════════════════════════════════════════════
  A: {
    GRANEL_SOLIDO: {
      2: { ccd: 4.0144, cc:  460.59 },
      3: { ccd: 5.1355, cc:  552.24 },
      4: { ccd: 5.8118, cc:  597.00 },
      5: { ccd: 6.6983, cc:  664.83 },
      6: { ccd: 7.3841, cc:  680.01 },
      7: { ccd: 8.0516, cc:  820.34 },
      9: { ccd: 9.2231, cc:  908.91 }
    },
    GRANEL_LIQUIDO: {
      2: { ccd: 4.0884, cc:  471.98 },
      3: { ccd: 5.2311, cc:  569.57 },
      4: { ccd: 5.9661, cc:  621.52 },
      5: { ccd: 6.8661, cc:  693.08 },
      6: { ccd: 7.5572, cc:  709.72 },
      7: { ccd: 8.1900, cc:  840.50 },
      9: { ccd: 9.3822, cc:  934.76 }
    },
    FRIGORIFICADA: {
      2: { ccd: 4.7095, cc:  520.07 },
      3: { ccd: 6.0159, cc:  623.27 },
      4: { ccd: 6.8646, cc:  686.63 },
      5: { ccd: 7.8666, cc:  757.98 },
      6: { ccd: 8.6661, cc:  772.35 },
      7: { ccd: 9.5884, cc:  982.76 },
      9: { ccd: 10.8870, cc: 1067.06 }
    },
    CONTEINERIZADA: {
      // 2 eixos sem valor oficial nesta faixa
      3: { ccd: 5.1082, cc:  544.75 },
      4: { ccd: 5.7396, cc:  577.15 },
      5: { ccd: 6.6345, cc:  647.29 },
      6: { ccd: 7.3186, cc:  662.01 },
      7: { ccd: 8.0492, cc:  819.69 },
      9: { ccd: 9.1399, cc:  886.05 }
    },
    CARGA_GERAL: {
      2: { ccd: 3.9826, cc:  451.84 },
      3: { ccd: 5.0977, cc:  541.86 },
      4: { ccd: 5.7822, cc:  588.86 },
      5: { ccd: 6.6718, cc:  657.56 },
      6: { ccd: 7.3547, cc:  671.93 },
      7: { ccd: 8.0927, cc:  831.66 },
      9: { ccd: 9.2027, cc:  903.32 }
    },
    NEOGRANEL: {
      2: { ccd: 3.6023, cc:  451.84 },
      3: { ccd: 5.0962, cc:  541.44 },
      4: { ccd: 5.8094, cc:  596.35 },
      5: { ccd: 6.6718, cc:  657.56 },
      6: { ccd: 7.3547, cc:  671.93 },
      7: { ccd: 8.0927, cc:  831.66 },
      9: { ccd: 9.2027, cc:  903.32 }
    },
    PERIGOSA_GRANEL_SOLIDO: {
      2: { ccd: 4.7845, cc:  608.79 },
      3: { ccd: 5.9154, cc:  703.16 },
      4: { ccd: 6.6285, cc:  753.03 },
      5: { ccd: 7.5150, cc:  820.86 },
      6: { ccd: 8.2008, cc:  836.04 },
      7: { ccd: 8.8866, cc:  981.39 },
      9: { ccd: 10.0660, cc: 1072.15 }
    },
    PERIGOSA_GRANEL_LIQUIDO: {
      2: { ccd: 4.8710, cc:  632.58 },
      3: { ccd: 6.0236, cc:  732.90 },
      4: { ccd: 6.7628, cc:  789.96 },
      5: { ccd: 7.6628, cc:  861.51 },
      6: { ccd: 8.3539, cc:  878.16 },
      7: { ccd: 9.0049, cc: 1013.95 },
      9: { ccd: 10.2051, cc: 1110.41 }
    },
    PERIGOSA_FRIGORIFICADA: {
      2: { ccd: 5.3176, cc:  630.88 },
      3: { ccd: 6.6369, cc:  737.63 },
      4: { ccd: 7.5020, cc:  807.63 },
      5: { ccd: 8.5039, cc:  878.98 },
      6: { ccd: 9.3034, cc:  893.35 },
      7: { ccd: 10.2495, cc: 1110.28 },
      9: { ccd: 11.5584, cc: 1197.43 }
    },
    PERIGOSA_CONTEINERIZADA: {
      // 2 eixos sem valor oficial
      3: { ccd: 5.4926, cc:  645.45 },
      4: { ccd: 6.1608, cc:  682.95 },
      5: { ccd: 7.0556, cc:  753.10 },
      6: { ccd: 7.7398, cc:  767.81 },
      7: { ccd: 8.4886, cc:  930.51 },
      9: { ccd: 9.5873, cc:  999.06 }
    },
    PERIGOSA_GERAL: {
      2: { ccd: 4.3571, cc:  549.81 },
      3: { ccd: 5.4821, cc:  642.55 },
      4: { ccd: 6.2033, cc:  694.66 },
      5: { ccd: 7.0930, cc:  763.36 },
      6: { ccd: 7.7758, cc:  777.73 },
      7: { ccd: 8.5321, cc:  942.48 },
      9: { ccd: 9.6501, cc: 1016.33 }
    },
    GRANEL_PRESSURIZADA: {
      // 2, 3, 4 e 7 eixos sem valor oficial
      5: { ccd: 7.0364, cc:  757.81 },
      6: { ccd: 7.7652, cc:  784.82 },
      9: { ccd: 9.7444, cc: 1052.26 }
    }
  },

  // ═══════════════════════════════════════════════════════════════════
  // TABELA B — Operações com contratação APENAS do veículo automotor
  //            (padrão, sem alto desempenho)
  // ═══════════════════════════════════════════════════════════════════
  B: {
    GRANEL_SOLIDO: {
      // 2 e 3 eixos sem valor oficial
      4: { ccd: 5.2180, cc: 533.40 },
      5: { ccd: 5.9334, cc: 594.62 },
      6: { ccd: 6.6063, cc: 608.99 },
      7: { ccd: 7.0381, cc: 720.31 },
      9: { ccd: 7.8292, cc: 773.22 }
    },
    GRANEL_LIQUIDO: {
      4: { ccd: 5.2831, cc: 533.40 },
      5: { ccd: 5.9986, cc: 594.62 },
      6: { ccd: 6.6714, cc: 608.99 },
      7: { ccd: 7.1032, cc: 720.31 },
      9: { ccd: 7.8943, cc: 773.22 }
    },
    FRIGORIFICADA: {
      4: { ccd: 6.1290, cc: 584.04 },
      5: { ccd: 6.9472, cc: 645.26 },
      6: { ccd: 7.7367, cc: 659.62 },
      7: { ccd: 8.1867, cc: 775.96 },
      9: { ccd: 9.1284, cc: 831.06 }
    },
    CONTEINERIZADA: {
      4: { ccd: 5.2180, cc: 533.40 },
      5: { ccd: 5.9334, cc: 594.62 },
      6: { ccd: 6.6063, cc: 608.99 },
      7: { ccd: 7.0381, cc: 720.31 },
      9: { ccd: 7.8292, cc: 773.22 }
    },
    CARGA_GERAL: {
      4: { ccd: 5.2180, cc: 533.40 },
      5: { ccd: 5.9334, cc: 594.62 },
      6: { ccd: 6.6063, cc: 608.99 },
      7: { ccd: 7.0381, cc: 720.31 },
      9: { ccd: 7.8292, cc: 773.22 }
    },
    NEOGRANEL: {
      4: { ccd: 5.2180, cc: 533.40 },
      5: { ccd: 5.9334, cc: 594.62 },
      6: { ccd: 6.6063, cc: 608.99 },
      7: { ccd: 7.0381, cc: 720.31 },
      9: { ccd: 7.8292, cc: 773.22 }
    },
    PERIGOSA_GRANEL_SOLIDO: {
      4: { ccd: 6.0347, cc: 689.44 },
      5: { ccd: 6.7502, cc: 750.65 },
      6: { ccd: 7.4230, cc: 765.02 },
      7: { ccd: 7.8730, cc: 881.36 },
      9: { ccd: 8.6721, cc: 936.46 }
    },
    PERIGOSA_GRANEL_LIQUIDO: {
      4: { ccd: 6.0798, cc: 701.84 },
      5: { ccd: 6.7953, cc: 763.06 },
      6: { ccd: 7.4681, cc: 777.43 },
      7: { ccd: 7.9181, cc: 893.76 },
      9: { ccd: 8.7172, cc: 948.87 }
    },
    PERIGOSA_FRIGORIFICADA: {
      4: { ccd: 6.7663, cc: 705.04 },
      5: { ccd: 7.5845, cc: 766.25 },
      6: { ccd: 8.3740, cc: 780.62 },
      7: { ccd: 8.8477, cc: 903.48 },
      9: { ccd: 9.7997, cc: 961.43 }
    },
    PERIGOSA_CONTEINERIZADA: {
      4: { ccd: 5.6391, cc: 639.21 },
      5: { ccd: 6.3546, cc: 700.42 },
      6: { ccd: 7.0274, cc: 714.79 },
      7: { ccd: 7.4774, cc: 831.13 },
      9: { ccd: 8.2766, cc: 886.23 }
    },
    PERIGOSA_GERAL: {
      4: { ccd: 5.6391, cc: 639.21 },
      5: { ccd: 6.3546, cc: 700.42 },
      6: { ccd: 7.0274, cc: 714.79 },
      7: { ccd: 7.4774, cc: 831.13 },
      9: { ccd: 8.2766, cc: 886.23 }
    },
    GRANEL_PRESSURIZADA: {
      // 2, 3, 4 e 7 eixos sem valor oficial
      5: { ccd: 5.9334, cc: 594.62 },
      6: { ccd: 6.6063, cc: 608.99 },
      9: { ccd: 7.8292, cc: 773.22 }
    }
  },

  // ═══════════════════════════════════════════════════════════════════
  // TABELA C — Composição veicular completa, ALTO DESEMPENHO
  // ═══════════════════════════════════════════════════════════════════
  C: {
    GRANEL_SOLIDO: {
      2: { ccd: 3.3964, cc: 174.38 },
      3: { ccd: 4.3276, cc: 198.05 },
      4: { ccd: 4.9441, cc: 215.03 },
      5: { ccd: 5.6725, cc: 229.64 },
      6: { ccd: 6.3229, cc: 232.91 },
      7: { ccd: 6.7071, cc: 270.36 },
      9: { ccd: 7.6912, cc: 292.59 }
    },
    GRANEL_LIQUIDO: {
      2: { ccd: 3.4439, cc: 176.84 },
      3: { ccd: 4.3828, cc: 201.78 },
      4: { ccd: 5.0412, cc: 220.31 },
      5: { ccd: 5.7745, cc: 235.73 },
      6: { ccd: 6.4268, cc: 239.32 },
      7: { ccd: 6.7985, cc: 274.70 },
      9: { ccd: 7.7901, cc: 298.16 }
    },
    FRIGORIFICADA: {
      2: { ccd: 4.0647, cc: 205.65 },
      3: { ccd: 5.1615, cc: 232.97 },
      4: { ccd: 5.9203, cc: 256.16 },
      5: { ccd: 6.7560, cc: 271.54 },
      6: { ccd: 7.5220, cc: 274.63 },
      7: { ccd: 8.0108, cc: 329.34 },
      9: { ccd: 9.1377, cc: 351.60 }
    },
    CONTEINERIZADA: {
      // 2 eixos sem valor oficial
      3: { ccd: 4.3178, cc: 196.43 },
      4: { ccd: 4.9182, cc: 210.75 },
      5: { ccd: 5.6496, cc: 225.87 },
      6: { ccd: 6.2994, cc: 229.04 },
      7: { ccd: 6.7062, cc: 270.22 },
      9: { ccd: 7.6614, cc: 287.67 }
    },
    CARGA_GERAL: {
      2: { ccd: 3.3850, cc: 172.50 },
      3: { ccd: 4.3141, cc: 195.81 },
      4: { ccd: 4.9335, cc: 213.27 },
      5: { ccd: 5.6630, cc: 228.08 },
      6: { ccd: 6.3124, cc: 231.17 },
      7: { ccd: 6.7218, cc: 272.80 },
      9: { ccd: 7.6839, cc: 291.39 }
    },
    NEOGRANEL: {
      2: { ccd: 3.0047, cc: 172.50 },
      3: { ccd: 4.3135, cc: 195.72 },
      4: { ccd: 4.9432, cc: 214.89 },
      5: { ccd: 5.6630, cc: 228.08 },
      6: { ccd: 6.3124, cc: 231.17 },
      7: { ccd: 6.7218, cc: 272.80 },
      9: { ccd: 7.6839, cc: 291.39 }
    },
    PERIGOSA_GRANEL_SOLIDO: {
      2: { ccd: 3.9329, cc: 224.77 },
      3: { ccd: 4.8748, cc: 250.19 },
      4: { ccd: 5.5294, cc: 270.47 },
      5: { ccd: 6.2578, cc: 285.09 },
      6: { ccd: 6.9083, cc: 288.36 },
      7: { ccd: 7.3121, cc: 329.05 },
      9: { ccd: 8.3048, cc: 352.70 }
    },
    PERIGOSA_GRANEL_LIQUIDO: {
      2: { ccd: 3.9640, cc: 229.89 },
      3: { ccd: 4.9136, cc: 256.60 },
      4: { ccd: 5.5777, cc: 278.43 },
      5: { ccd: 6.3109, cc: 293.85 },
      6: { ccd: 6.9633, cc: 297.43 },
      7: { ccd: 7.3546, cc: 336.06 },
      9: { ccd: 8.3548, cc: 360.94 }
    },
    PERIGOSA_FRIGORIFICADA: {
      2: { ccd: 4.5599, cc: 253.51 },
      3: { ccd: 5.6705, cc: 283.12 },
      4: { ccd: 6.4476, cc: 310.60 },
      5: { ccd: 7.2833, cc: 325.98 },
      6: { ccd: 8.0493, cc: 329.07 },
      7: { ccd: 8.5636, cc: 388.00 },
      9: { ccd: 9.7016, cc: 412.10 }
    },
    PERIGOSA_CONTEINERIZADA: {
      // 2 eixos sem valor oficial
      3: { ccd: 4.5865, cc: 237.75 },
      4: { ccd: 5.2250, cc: 255.37 },
      5: { ccd: 5.9564, cc: 270.49 },
      6: { ccd: 6.6062, cc: 273.66 },
      7: { ccd: 7.0327, cc: 318.08 },
      9: { ccd: 7.9965, cc: 336.95 }
    },
    PERIGOSA_GERAL: {
      2: { ccd: 3.6430, cc: 212.06 },
      3: { ccd: 4.5827, cc: 237.13 },
      4: { ccd: 5.2403, cc: 257.89 },
      5: { ccd: 5.9698, cc: 272.70 },
      6: { ccd: 6.6192, cc: 275.79 },
      7: { ccd: 7.0483, cc: 320.66 },
      9: { ccd: 8.0190, cc: 340.67 }
    },
    GRANEL_PRESSURIZADA: {
      // 2, 3, 4 e 7 eixos sem valor oficial
      5: { ccd: 5.7939, cc: 249.68 },
      6: { ccd: 6.4598, cc: 255.50 },
      9: { ccd: 7.8784, cc: 323.48 }
    }
  },

  // ═══════════════════════════════════════════════════════════════════
  // TABELA D — Apenas veículo automotor, ALTO DESEMPENHO
  // ═══════════════════════════════════════════════════════════════════
  D: {
    GRANEL_SOLIDO: {
      // 2 e 3 eixos sem valor oficial
      4: { ccd: 4.4985, cc: 201.32 },
      5: { ccd: 5.0713, cc: 214.52 },
      6: { ccd: 5.7107, cc: 217.61 },
      7: { ccd: 5.9267, cc: 248.80 },
      9: { ccd: 6.6136, cc: 263.35 }
    },
    GRANEL_LIQUIDO: {
      4: { ccd: 4.5636, cc: 201.32 },
      5: { ccd: 5.1364, cc: 214.52 },
      6: { ccd: 5.7758, cc: 217.61 },
      7: { ccd: 5.9918, cc: 248.80 },
      9: { ccd: 6.6787, cc: 263.35 }
    },
    FRIGORIFICADA: {
      4: { ccd: 5.4237, cc: 234.06 },
      5: { ccd: 6.0993, cc: 247.25 },
      6: { ccd: 6.8553, cc: 250.34 },
      7: { ccd: 7.0910, cc: 284.78 },
      9: { ccd: 7.9290, cc: 300.75 }
    },
    CONTEINERIZADA: {
      4: { ccd: 4.4985, cc: 201.32 },
      5: { ccd: 5.0713, cc: 214.52 },
      6: { ccd: 5.7107, cc: 217.61 },
      7: { ccd: 5.9267, cc: 248.80 },
      9: { ccd: 6.6136, cc: 263.35 }
    },
    CARGA_GERAL: {
      4: { ccd: 4.4985, cc: 201.32 },
      5: { ccd: 5.0713, cc: 214.52 },
      6: { ccd: 5.7107, cc: 217.61 },
      7: { ccd: 5.9267, cc: 248.80 },
      9: { ccd: 6.6136, cc: 263.35 }
    },
    NEOGRANEL: {
      4: { ccd: 4.4985, cc: 201.32 },
      5: { ccd: 5.0713, cc: 214.52 },
      6: { ccd: 5.7107, cc: 217.61 },
      7: { ccd: 5.9267, cc: 248.80 },
      9: { ccd: 6.6136, cc: 263.35 }
    },
    PERIGOSA_GRANEL_SOLIDO: {
      4: { ccd: 5.0838, cc: 256.77 },
      5: { ccd: 5.6566, cc: 269.96 },
      6: { ccd: 6.2960, cc: 273.05 },
      7: { ccd: 6.5317, cc: 307.49 },
      9: { ccd: 7.2272, cc: 323.46 }
    },
    PERIGOSA_GRANEL_LIQUIDO: {
      4: { ccd: 5.1000, cc: 259.44 },
      5: { ccd: 5.6728, cc: 272.63 },
      6: { ccd: 6.3122, cc: 275.73 },
      7: { ccd: 6.5479, cc: 310.16 },
      9: { ccd: 7.2434, cc: 326.13 }
    },
    PERIGOSA_FRIGORIFICADA: {
      4: { ccd: 5.9510, cc: 288.50 },
      5: { ccd: 6.6265, cc: 301.69 },
      6: { ccd: 7.3826, cc: 304.78 },
      7: { ccd: 7.6438, cc: 343.44 },
      9: { ccd: 8.4930, cc: 361.25 }
    },
    PERIGOSA_CONTEINERIZADA: {
      4: { ccd: 4.8053, cc: 245.95 },
      5: { ccd: 5.3781, cc: 259.14 },
      6: { ccd: 6.0175, cc: 262.23 },
      7: { ccd: 6.2532, cc: 296.67 },
      9: { ccd: 6.9487, cc: 312.64 }
    },
    PERIGOSA_GERAL: {
      4: { ccd: 4.8053, cc: 245.95 },
      5: { ccd: 5.3781, cc: 259.14 },
      6: { ccd: 6.0175, cc: 262.23 },
      7: { ccd: 6.2532, cc: 296.67 },
      9: { ccd: 6.9487, cc: 312.64 }
    },
    GRANEL_PRESSURIZADA: {
      // 2, 3, 4 e 7 eixos sem valor oficial
      5: { ccd: 5.0713, cc: 214.52 },
      6: { ccd: 5.7107, cc: 217.61 },
      9: { ccd: 6.6136, cc: 263.35 }
    }
  }
}

// Alias de compatibilidade: codigo antigo importava TABELAS_ANTT_6076_2026.
// Mantemos o export com o nome antigo apontando pra estrutura nova pra
// nao quebrar imports existentes.
export const TABELAS_ANTT_6076_2026 = TABELAS_ANTT_6084_2026

export function getCoeficientes(tabela, tipoCarga, eixos){
  const t = TABELAS_ANTT_6084_2026[tabela]
  if(!t) return null
  const c = t[tipoCarga]
  if(!c) return null
  return c[eixos] || null
}

export function calcularPisoFrete({ tabela, tipoCarga, eixos, distanciaKm }){
  const dist = Number(distanciaKm)
  if(!dist || dist <= 0){
    return { erro: 'Informe uma distância maior que zero (km).' }
  }
  const coef = getCoeficientes(tabela, tipoCarga, eixos)
  if(!coef){
    return {
      erro: 'Coeficiente não cadastrado para essa combinação. Consulte o Anexo da Resolução ANTT 6.084/2026.'
    }
  }
  const piso = coef.ccd * dist + coef.cc
  return {
    ccd: coef.ccd,
    cc: coef.cc,
    distanciaKm: dist,
    piso,
    valorPorKm: piso / dist
  }
}

export function compararValor(piso, valorPretendido){
  const v = Number(valorPretendido)
  if(!v || v <= 0) return null
  const diff = v - piso
  const pct = (diff / piso) * 100
  return {
    valorPretendido: v,
    diferenca: diff,
    percentual: pct,
    acimaDoPiso: diff >= 0
  }
}
